// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../../../Config.bs.js";
import * as TicketingOrderRepo from "./TicketingOrderRepo.bs.js";
import * as DummyTicketingOrderRepo from "./DummyTicketingOrderRepo.bs.js";

function getTicketingOrderRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyTicketingOrderRepo.TicketingOrderRepo;
  } else {
    return TicketingOrderRepo.TicketingOrderRepo;
  }
}

export {
  getTicketingOrderRepo ,
  
}
/* Config Not a pure module */
